import { IdeaSummaryCard } from './idea-summary-card.tsx'
import ReactECharts from 'echarts-for-react'
import Spin from 'antd/es/spin/index'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import { SummaryInfoHelp } from './idea-list-summary-info-help.tsx'
import { SummaryValueText } from './idea-summary-value-text.tsx'

interface IdeaSummaryBpUsageProps {
  shouldShowSelectContributorMsg: boolean
  isLoading?: boolean
  usedBuyingPower: number
  totalBuyingPower: number
  deployment: number
}

export const IdeaSummaryBpUsageCard: React.FC<IdeaSummaryBpUsageProps> = ({
  shouldShowSelectContributorMsg,
  isLoading,
  usedBuyingPower,
  totalBuyingPower,
  deployment,
}) => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)
  const bpFractionRaw = usedBuyingPower / totalBuyingPower
  const bpFraction = Number.isNaN(bpFractionRaw) ? 0 : bpFractionRaw

  const option = {
    grid: {
      containLabel: false,
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    series: [
      {
        name: 'Percentage',
        type: 'gauge',
        radius: '95%',
        startAngle: 90,
        endAngle: -270,
        progress: {
          show: bpFraction !== 0,
          width: 4,
          roundCap: true,
        },
        itemStyle: {
          color: themeStyle.geekblue6,
        },
        axisLine: {
          lineStyle: {
            width: 4,
            color: [
              [
                bpFraction, // percent filled
                themeStyle.blue6, // filled color
              ],
              [1, themeStyle.remainingColor],
            ],
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        pointer: {
          show: false,
        },
        detail: {
          width: '60%',
          offsetCenter: [0, 0],
          formatter: '{value}%',
          fontSize: '1rem',
          fontFamily: 'FigTree, Arial, sans-serif',
          fontWeight: 'normal',
          color: themeStyle.gaugeText,
        },
        data: [
          {
            value: (bpFraction * 100).toFixed(0),
            name: '',
          },
        ],
      },
    ],
  }

  const overlayComponent = shouldShowSelectContributorMsg ? (
    <SummaryInfoHelp />
  ) : isLoading ? (
    <Spin />
  ) : null

  return (
    <IdeaSummaryCard
      title={'BP Deployment'}
      overlayMsg={overlayComponent}
      slotComponent={
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
          }}
        >
          <ReactECharts
            option={option}
            style={{
              width: '3.75rem',
              height: '3.75rem',
            }}
            notMerge
          />
        </div>
      }
      textComponent={
        <SummaryValueText
          value={`${(usedBuyingPower / 1_000_000).toFixed(1)}M`}
          suffix={`/${(totalBuyingPower / 1_000_000).toFixed(0)}M`}
        />
      }
      rows={[
        {
          label: t('dashboard.average_deployment'),
          value: `${(deployment * 100).toFixed(2)}%`,
        },
      ]}
    ></IdeaSummaryCard>
  )
}
